/* eslint-disable react-hooks/exhaustive-deps */
import { audit } from "./analytics";
import { useState, useEffect } from "react";

export const auditAdvertView = (advert) =>
  audit({
    type: "banner-view",
    payload: {
      id: advert.name || advert.id,
      title: advert.title || advert.heading,
    },
  });

export const auditAdvertClick = (advert) => () =>
  audit({
    type: "banner-click",
    payload: {
      id: advert.name || advert.id,
      title: advert.title || advert.heading,
    },
  });

export const auditLocationChange = (_state, action) =>
  audit({
    type: "navigation-event",
    payload: {
      pathname: action.payload.location.pathname,
      search: action.payload.location.search,
    },
  });

export const auditMenuClick = (link) => {
  audit({
    type: "menu-click-event",
    payload: {
      link,
    },
  });
};

export const auditAddToReadingList = (pid) => {
  audit({
    type: "add-to-reading-list-event",
    payload: {
      pid,
    },
  });
};

export const auditSwitchToRedesign = (isToRedesign = true) => {
  audit({
    type: "feature-usage-event",
    payload: { featureName: "switch-to-redesign", value: isToRedesign?.toString() },
  });
};

export const auditRegisterToEvent = (eventId) => {
  audit({
    type: "feature-usage-event",
    payload: { featureName: "register-to-event", value: eventId },
  });
};

export const auditAddEventToCalendar = (eventId) => {
  audit({
    type: "feature-usage-event",
    payload: { featureName: "add-event-to-calendar", value: eventId },
  });
};

export const auditVimeoPlay = (id) => {
  audit({
    type: "feature-usage-event",
    payload: { featureName: "vimeo-play", value: id },
  });
};

export const auditFeatureReportClick = (id) => {
  audit({
    type: "feature-report-click",
    payload: {
      id
    },
  });
};

export const auditChatbotClick = () => {
  audit({
    type: "feature-usage-event",
    payload: { featureName: "chatbot-open", value: "open" },
  });
};

export const auditAiSummaryClick = (publicationId) => {
  audit({
    type: "feature-usage-event",
    payload: { featureName: "ai-summary-open", value: publicationId },
  });
};

export const auditShareSubscriptionLink = (publicationId, source) => {
  audit({
    type: "feature-usage-event",
    payload: { featureName: "share-subscription-link", value: publicationId, source },
  });
};

export const auditOnSubscription = (subscriptionName, type = "subscription-success") => {
  audit({
    type: type,
    payload: { featureName: "grp-easy-subscriptions", value: subscriptionName },
  });
}
export const auditOnThemeInFocus = (themeName) => {
  audit({
    type: "theme-in-focus-click",
    payload: { featureName: "theme-in-focus", value: themeName },
  });
}

// only audit banner views on first view
export const useAuditAdvert = (adverts) => {
  const [adsViewed, setAdsViewed] = useState([0]);
  useEffect(() => auditAdvertByIndex(adverts, 0), []);

  const auditAdvertView = (index) => {
    if (!adsViewed.includes(index)) {
      auditAdvertByIndex(adverts, index);
      setAdsViewed(adsViewed.concat(index));
    } // else ignore repeat view
  };
  return auditAdvertView;
};

const auditAdvertByIndex = (adverts, index) => adverts[index] && auditAdvertView(adverts[index]);
